export const localeConstant = [
  { title: 'ua', id: 1 },
  { title: 'en', id: 2 },
];

export const mainLocaleConstant = localeConstant[0];
